import {
    NinchatActionType,
    NinchatCreateTagAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const createTag = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatCreateTagAction}`,
    async (arg: NinchatActionParams<NinchatCreateTagAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatCreateTagAction

        try {
            return await ninchatClient.send(params)
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
